export default __webpack_public_path__ + "static/IBMPlexSans-Italic-Cyrillic-f5be008474d38b4cf15a0431777dfaf2.woff";